import app_img from '@/public/article/App.webp';
import managment_img from '@/public/article/Customer management.webp';
import invoicing from '@/public/article/Invoice.webp';
import article1 from '@/public/article/picture.webp';
import schedule_img from '@/public/article/Schedule_1.webp';
import main_bg from '@/public/industries/handyman/handyman.webp';
import image4 from '@/public/industries/hvac/Reporting-and-analytics.webp';
import review1 from '@/public/reviews/CapterraSvg.svg';
import review2 from '@/public/reviews/GetAppSvg.svg';
import review3 from '@/public/reviews/SoftwareAdvice.svg';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const faq = [
  {
    title: 'What are the benefits of residential cleaning business software?',
    text: `Residential house cleaning software streamlines operations boosts efficiency, enhances
    customer service, and provides insightful analytics for better business decisions.`,
  },
  {
    title: `How does Orcatec home cleaning management software help my
    business?`,
    text: `Orcatec helps by optimizing scheduling, managing customer data, facilitating communication,
    and simplifying billing processes.`,
  },
  {
    title: 'Can I customize Orcatec Software for my business needs?',
    text: `Our platform is designed for easy customization, allowing you to tailor the software to your
    cleaning business's unique processes and preferences. This means you can adjust workflows,
    reporting, and more to match exactly how you operate.`,
  },

  {
    title:
      'Does your residential cleaning business software have a mobile app?',
    text: `Yes, Orcatec offers a mobile app for on-the-go management that is compatible with iOS and
    Android devices.`,
  },
  {
    title: `Why is Orcatec considered among the best software for a cleaning
    business?`,
    text: `Orcatec is top-tier due to its comprehensive features, user-friendly interface, and customizable
    solutions for small and large-scale operations.`,
  },
];

const testimonals = [
  {
    text: `Integrating Orcatec into my business has been a revelation. Our teams work more cohesively,
    and our customers rave about the consistency of service. Orcatec isn't just the help of cleaning
    business management software; it's an essential team member.`,
    name: 'Greg H.,',
    position: 'Brighter Days Cleaning Co',
  },
  {
    text: `As we expanded Clean Horizon, managing a growing team and client base seemed daunting.
    Orcatec's scalable software grew with us, offering the flexibility and control we needed.`,
    name: 'Sophia R.,',
    position: 'Clean Horizon',
  },
  {
    text: `Orcatec has changed the way we manage our cleaning services. The user-friendly interface and
    mobile accessibility have empowered our staff to deliver exceptional service with unprecedented
    efficiency.`,
    name: 'Omar J.,',
    position: 'Sparkling Spaces',
  },
  {
    text: `Integrating Orcatec into my business has been a revelation. Our teams work more cohesively,
    and our customers rave about the consistency of service. Orcatec isn't just the help of cleaning
    business management software; it's an essential team member.`,
    name: 'Greg H.,',
    position: 'Brighter Days Cleaning Co',
  },
  {
    text: `As we expanded Clean Horizon, managing a growing team and client base seemed daunting.
    Orcatec's scalable software grew with us, offering the flexibility and control we needed.`,
    name: 'Sophia R.,',
    position: 'Clean Horizon',
  },
  {
    text: `Orcatec has changed the way we manage our cleaning services. The user-friendly interface and
    mobile accessibility have empowered our staff to deliver exceptional service with unprecedented
    efficiency.`,
    name: 'Omar J.,',
    position: 'Sparkling Spaces',
  },
];

const industries = {
  title: 'Our industries',
  description: `Orcatec is a flexible platform that is suitable for companies providing field services. We designed our field service management software to meet the diverse needs.`,
  items: [
    { title: 'HVAC', path: IRoutePath.INDUSTRIES_HVAC },
    { title: 'Plumbing', path: IRoutePath.INDUSTRIES_PLUMBING },
    { title: 'Appliance Repair', path: IRoutePath.INDUSTRIES_APPLIANCE },
    { title: 'Electrician', path: IRoutePath.INDUSTRIES_ELECTRICIAN },
    { title: 'Garage Door', path: IRoutePath.INDUSTRIES_GARAGE_DOOR },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Property Maintenance',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Junk Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Home Cleaning',
      path: IRoutePath.INDUSTRIES_HOME_CLEANING,
    },
    {
      title: 'Handyman',
      path: IRoutePath.INDUSTRIES_HANDYMAN,
    },
    {
      title: 'Landscaping and Lawn',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES_CONSTRUCTION,
    },

    {
      title: 'Home Renovation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Automotive',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pest Control',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Window Cleaning',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Carpet Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pool and Spa Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Locksmith',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fireplace and Chimney',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Roofing',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Water Treatment',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Alarm and Security',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Irrigation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Painting Contractors',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fire Safety',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Computer Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Moving',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Air Duct Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Remodeling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Janitorial Services',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Excavation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Demolition Contractor',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tree Care',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Restoration',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Flooring',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tiling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Drywall',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pressure Washing',
      path: IRoutePath.INDUSTRIES,
    },
  ],
};

const articles = {
  title: `Software Features Made for Home Cleaning Businesses`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_img,
        alt: 'Schedule appointments for your cleaning force',
      },
      href: '#',
      tag: 'Job Scheduling',
      title: `Schedule Appointments for Your Cleaning Force`,
      text: `Our dynamic scheduling feature automates and optimizes your appointment booking process.
      This tool allows for easy management of cleaner availability, customer preferences, and
      recurring appointments, ensuring efficient resource allocation and maximization of daily
      bookings. It solves the problem of manual scheduling, reducing conflicts and missed
      appointments.`,
      list: [
        {
          text: 'Assigning tasks to available technicians in just two clicks.',
        },
        { text: 'Easy calendar management with color-coded organization.' },
        {
          text: 'Automatically generate the fastest and most cost-effective routes on the map.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: managment_img,
        alt: 'Customer management',
      },
      href: '#',
      tag: 'Efficient Client Management',
      title: 'Access all Customer Information within Mobile App',
      text: `Keep all your customer information, from contact details to service history, accessible. This
      centralized client management system enhances relationship management by providing
      personalized service insights and quick access to each customer's preferences and feedback. It
      addresses the challenge of scattered information, improving service consistency and customer
      satisfaction.`,
      list: [
        { text: 'All essential project information in one place.' },
        { text: 'Converting one-time clients to regulars through email.' },
        { text: 'Automated check-in requests upon completion of work.' },
        {
          text: 'Creating professional email and text message templates in Orcatec.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: invoicing,
        alt: 'Simplified Invoicing and Payments',
      },
      href: '#',
      tag: 'Simplified Invoicing and Payments',
      title: 'Accept Credit Card Payments on the Go',
      text: `With our integrated invoicing and payment processing system, you can automatically generate and send invoices to clients after service completion. This feature facilitates timely payments by offering various convenient payment methods, significantly reducing the administrative burden of billing and improving cash flow. Interchange + 0.4% The lowest rate in the industry.`,

      list: [
        { text: 'Ability to send an invoice for payment with just one click.' },
        {
          text: 'Automatic reminders to clients for outstanding invoice payments.',
        },
        { text: 'Mobile credit card terminals.' },
        { text: 'Instant notification if the invoice has been paid.' },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: image4.src,
        alt: 'Reporting and analytics',
      },
      href: '#',
      tag: 'Insightful Analytics and Reporting',
      title: 'Make Decisions Based On Data',
      text: `Leverage detailed analytics and custom reports to gain valuable insights into your business performance. This feature helps identify trends, track growth, and make informed decisions based on data like revenue, service popularity, and customer retention rates. It solves the problem of guesswork in business planning and offers a data-driven approach to growth.`,
      list: [
        {
          text: 'Tracking the most effective sources of work to optimize marketing expenses.',
        },
        {
          text: 'Easy control over current and projected profits based on scheduled jobs.',
        },
      ],
    },
  ],
};

const intro = {
  imageSrc: main_bg,
  tag: 'Home Cleaning Service Software',
  title: {
    first_part: 'Elevate Your Cleaning Business with ',
    second_part: 'Smart Software',
  },
  description: `Automate scheduling, simplify invoicing, and maximize efficiency with Orcatec software.`,
  info: [
    { title: '40 hours', description: 'Reduced Monthly Paperwork' },
    { title: '35%', description: 'Workforce Productivity' },
  ],
};

const fullArticle1 = {
  image: {
    path: article1.src,
    alt: 'What Is Home Cleaning Software?',
  },
  title: 'What Is Home Cleaning Software?',
  description: `Home cleaning company software is a digital solution specifically designed to streamline residential cleaning services' operations. This type of software aids businesses in efficiently managing scheduling, customer information, invoicing, payment processing, and workforce management within a single platform. By automating many of the administrative tasks associated with running a cleaning business, this software frees up business owners and managers to focus on growth and service quality.
  Orcatec offers a comprehensive cleaning services software solution tailored to the cleaning industry's unique needs. `,
  item: [
    {
      title: 'AI route optimizer',
      description: `Orcatec’s platform uses intelligent algorithms to optimize schedules and dispatch cleaners based on location, availability, and customer preferences.`,
    },
    {
      title: 'Fast access to projects data',
      description: `Orcatec provides a centralized database for all customer information, including preferences, service history, and payment records. `,
    },
    {
      title: 'Credit card processing',
      description: `Cleaning service software streamlines the billing process by automatically generating invoices based on completed services and processing payments securely online, improving cash flow and reducing administrative overhead.`,
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_img,
    alt: 'Why Orcatec Is Right For You?',
  },
  title: 'Why Orcatec Is Right For You?',
  description: `For many reasons, Orcatec stands out as the go-to software for cleaning companies. Each
  feature and service we offer is designed with the cleaning industry's unique needs in mind,
  ensuring that our software not only meets but exceeds the expectations of contractors in this
  field.`,
  item: [
    {
      title: 'Zero-Cost Entry',
      description: `Use our free starter package to begin with no upfront investment. It’s ideal for new or
      small businesses to experience the benefits of digital transformation without the financial
      burden.`,
    },
    {
      title: 'Customizable Functional',
      description: `With Orcatec, you can select and pay for only the needed features. This a-la-carte
      approach to functionality ensures that you can scale your software usage as your
      business grows without overspending on unnecessary features.`,
    },
    {
      title: 'Easy-To-Use Cross-platform Software',
      description: `Orcatec’s software is compatible with various devices, including PCs, tablets, mobile
      phones, and iOS and Android operating systems. This flexibility ensures that you, your
      managers, and your cleaning staff can access the system anytime, fostering greater
      efficiency and responsiveness.`,
    },
  ],
};

const reviews = {
  title: 'Our Reviews',
  items: [
    { path: review1.src, width: review1.width, alt: 'Capterra' },
    { path: review2.src, width: review2.width, alt: 'GetApp' },
    { path: review3.src, width: review3.width, alt: 'Software Advice' },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `It is your premier destination for insights and tips in the cleaning business industry. Dive into our
  latest articles to discover how technology revolutionizes efficiency and customer satisfaction in
  residential cleaning.`,
};

const bookDemo = {
  title: 'Schedule A Demo For the Next Step',
  description: `Fill in the information below to schedule a free, personalized demo and see first-hand how our
  solutions can streamline your operations, delight your customers, and grow your business. Don't
  wait to transform your service – reach out now and embrace the future of software for cleaning
  business management.`,
};

export {
  reviews,
  fullArticle2,
  fullArticle1,
  intro,
  articles,
  industries,
  testimonals,
  faq,
  blog,
  bookDemo,
};
